import React, { memo } from 'react';
import { WbMarkdownHtml } from '../../../utils/common';

const RatingComp = ({ value = 0, goalId = 0 } = props) => {
  const rating = Array.from(Array(5).keys()).map(i => i + 1).reverse();
  const isChecked = (v, value) => ((v == value) ? 'checked="checked"' : '');
  const content = rating.map(v => `<input disabled="disabled" value=${v} ${isChecked(v, value)} type="radio" name=${`rating${goalId}`} id=${`rating${goalId}-${v}`} /><label for=${`rating${goalId}-${v}`}></label>`).join('');
  return (
    <>
      <span className="screen-reader-only">{value + " Star"}</span>
      <div className="wbcss-star-rating  wbcss-star-rating-disabled" id={`wbcss-star-rating-closed-goal-rating-${goalId}`} dangerouslySetInnerHTML={WbMarkdownHtml(content)}></div>
    </>
  );
};

export default memo(RatingComp);